module.exports = __webpack_public_path__ + "img/logo3.5651cc29.png";